export const API_BASE_URL = "https://api.medbot.vanshiz.dev";

export const SENTIMENT_API_URL = "https://ai.medbot.vanshiz.dev";

// export const API_BASE_URL = "http://localhost:5050";
